import { useFeatureUpdatePopup } from "../../hooks/useFeatureUpdatePopup";
import FeatureUpdatePopupDialog from "./FeatureUpdatePopupDialog";

type FeatureUpdatePopupProps = {
  /** Opens the full updates window. */
  onOpenAll?: () => void;
};

/**
 * The big update a customer has not seen yet, opened by itself once Haim approved it
 * (featureUpdatePopups.ts). Renders nothing otherwise, which is almost always.
 */
export default function FeatureUpdatePopup({ onOpenAll }: FeatureUpdatePopupProps) {
  const { update, dismiss } = useFeatureUpdatePopup();
  if (!update) return null;

  return (
    <FeatureUpdatePopupDialog
      update={update}
      open
      onClose={dismiss}
      onOpenAll={
        onOpenAll &&
        (() => {
          dismiss();
          onOpenAll();
        })
      }
    />
  );
}
